module.exports = __webpack_public_path__ + "static/media/image1.2639c16c.png";